
import React from 'react';



type Props = {
  className?: string;
}
export const ServiceInternetShopVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'white' d = 'M13.6357 11.3C14.2355 11.3 14.7633 10.972 15.0352 10.476L17.8981 5.284C18.194 4.756 17.8101 4.1 17.2024 4.1H5.36675L4.61503 2.5H2V4.1H3.59941L6.47834 10.172L5.39874 12.124C4.81495 13.196 5.58267 14.5 6.79822 14.5H16.3947V12.9H6.79822L7.67789 11.3H13.6357ZM6.12647 5.7H15.8429L13.6357 9.7H8.02176L6.12647 5.7ZM6.79822 15.3C5.91854 15.3 5.20681 16.02 5.20681 16.9C5.20681 17.78 5.91854 18.5 6.79822 18.5C7.67789 18.5 8.39762 17.78 8.39762 16.9C8.39762 16.02 7.67789 15.3 6.79822 15.3ZM14.7952 15.3C13.9156 15.3 13.2038 16.02 13.2038 16.9C13.2038 17.78 13.9156 18.5 14.7952 18.5C15.6749 18.5 16.3947 17.78 16.3947 16.9C16.3947 16.02 15.6749 15.3 14.7952 15.3Z' />
    </svg>
  );
};
